<div class="tw-contents">
    <app-card 
        [fullWidth]="false"
        [withCard]="true"
        [cardTitle]="'PRINTERS.DETAIL.DAILY' | translate"
    >
        <section class="tw-grid tw-grid-cols-1 tw-gap-3 tw-p-1 tw-items-center">
    
            <div class="tw-flex tw-gap-2">
                <app-action-btn variant="stroked" type="secondary"
                    (click)="dailyRead()">
                    {{'PRINTERS.DETAIL.READ' | translate}}
                </app-action-btn>

                <app-action-btn variant="stroked" type="secondary"
                    (click)="dailyClosing()">
                    {{'PRINTERS.DETAIL.CLOSE' | translate}}
                </app-action-btn>
            </div>

        </section>
    </app-card>

    <app-card 
        [fullWidth]="false"
        [withCard]="true"
        [cardTitle]="'PRINTERS.DETAIL.CASH' | translate"
    >
        <section class="tw-grid tw-grid-cols-1 tw-gap-3 tw-p-1">

            <!-- <div class="tw-flex tw-flex-col tw-gap-4" [formGroup]="cashForm">
                <mat-button-toggle-group 
                    formControlName="type" 
                    class="custom-toggle-group tw-rounded-xl"
                    appearance="standard">
                    <mat-button-toggle value="deposit" class="tw-h-9 tw-flex tw-items-center">
                        {{'PRINTERS.DETAIL.DEPOSIT' | translate}}
                    </mat-button-toggle>
                    <mat-button-toggle value="withdrawal" class="tw-h-9 tw-flex tw-items-center">
                        {{'PRINTERS.DETAIL.WITHDRAWAL' | translate}}
                    </mat-button-toggle>
                </mat-button-toggle-group>

                <div class="tw-flex tw-items-start tw-gap-3">
                    <mat-form-field class="tw-flex-1">
                        <mat-label>{{'PRINTERS.DETAIL.AMOUNT_CASH' | translate}}</mat-label>
                        <input matInput type="number" step="0.01" formControlName="amount">
                        @if (cashForm.controls.amount.hasError('min')) {
                            <mat-error>{{'NG_MESSAGES.NUMBER_NOT_VALID' | translate}}</mat-error>
                        }
                        @if (cashForm.controls.amount.hasError('pattern')) {
                            <mat-error>{{'NG_MESSAGES.INVALID_VALUE' | translate}}</mat-error>
                        }
                    </mat-form-field>

                    <app-action-btn 
                        class="tw-mt-1.5" variant="stroked"
                        [disabled]="cashForm.invalid || !cashForm.controls.amount.value"
                        (click)="executeCashOperation()">
                        {{ (currentCashType === 'deposit' ? 'PRINTERS.DETAIL.DEPOSIT_ACTION' : 'PRINTERS.DETAIL.WITHDRAWAL_ACTION') | translate }}
                    </app-action-btn>
                </div>
            </div> -->

            <div class="tw-flex tw-items-start tw-gap-4">
                <mat-form-field class="tw-flex-1">
                    <mat-label>{{'PRINTERS.DETAIL.AMOUNT_CASH' | translate}}</mat-label>
                    <input matInput type="number" step="0.01" [formControl]="cashControl">
                    @if (cashControl.hasError('min')) {
                        <mat-error>{{'NG_MESSAGES.NUMBER_NOT_VALID' | translate}}</mat-error>
                    } @else if (cashControl.hasError('pattern')) {
                        <mat-error>{{'NG_MESSAGES.INVALID_VALUE' | translate}}</mat-error>
                    }
                </mat-form-field>

                <div class="tw-flex tw-gap-2 tw-mt-1.5">
                    <app-action-btn variant="stroked" 
                        [disabled]="cashControl.invalid || !cashControl.value" 
                        (click)="deposit(cashControl.value!)">
                        {{'PRINTERS.DETAIL.DEPOSIT_ACTION' | translate}}
                    </app-action-btn>
                    
                    <app-action-btn variant="stroked"
                        [disabled]="cashControl.invalid  || !cashControl.value" 
                        (click)="withdrawal(cashControl.value!)">
                        {{'PRINTERS.DETAIL.WITHDRAWAL_ACTION' | translate}}
                    </app-action-btn>
                </div>
            </div>

        </section>
    </app-card>

    <app-card 
        [fullWidth]="false"
        [withCard]="true"
        [cardTitle]="'PRINTERS.DETAIL.FISCAL_MEMORY' | translate"
    >
        <section class="tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-3 tw-items-center tw-px-1" [formGroup]="fiscalMemoryForm">

            <div class="tw-col-span-12">
                <mat-slide-toggle formControlName="corrispettivi" class="tw-flex tw-py-3">
                    <span class="tw-flex tw-ml-2">{{'PRINTERS.DETAIL.CORRISPETTIVI' | translate}}</span>
                </mat-slide-toggle>
            </div>

            <mat-form-field class="tw-col-span-12 md:tw-col-span-6">
                <mat-label>{{ "PRINTERS.DETAIL.FROM" | translate }}</mat-label>
                <input matInput [matDatepicker]="picker_from" formControlName="from_date">
                <mat-datepicker-toggle matIconSuffix [for]="picker_from"></mat-datepicker-toggle>
                <mat-datepicker #picker_from></mat-datepicker>
            </mat-form-field>

            <mat-form-field class="tw-col-span-12 md:tw-col-span-6">
                <mat-label>{{ "PRINTERS.DETAIL.TO" | translate }}</mat-label>
                <input matInput [matDatepicker]="picker_to" 
                    [min]="fiscalMemoryForm.get('from_date')?.value"
                    formControlName="to_date">
                <mat-datepicker-toggle matIconSuffix [for]="picker_to"></mat-datepicker-toggle>
                <mat-datepicker #picker_to></mat-datepicker>
            </mat-form-field>

            <div class="tw-col-span-12 md:tw-col-span-6">
                <app-action-btn variant="stroked" [fullWidth]="true"
                    class="tw-w-full"
                    [disabled]="fiscalMemoryForm.invalid || !fiscalMemoryForm.controls.from_date.value || 
                        !fiscalMemoryForm.controls.to_date.value" 
                    (click)="printFiscalMemoryBetween()">
                    {{'PRINTERS.DETAIL.PRINT_SELECTION' | translate}}
                </app-action-btn>
            </div>

            <div class="tw-col-span-12 md:tw-col-span-6">
                <app-action-btn variant="stroked" [fullWidth]="true"
                    class="tw-w-full"
                    (click)="printFiscalMemory()">
                    {{'PRINTERS.DETAIL.PRINT_ALL' | translate}}
                </app-action-btn>
            </div>
        </section>
    </app-card>
    
    <app-card 
        [fullWidth]="false"
        [withCard]="true"
        [cardTitle]="'PRINTERS.DETAIL.DGFE' | translate"
    >
        <section class="tw-grid tw-grid-cols-1 md:tw-grid-cols-12 tw-gap-3 tw-items-center tw-p-1" [formGroup]="dgfeForm">

            <mat-form-field class="tw-col-span-12 md:tw-col-span-6">
                <mat-label>{{ "PRINTERS.DETAIL.FROM" | translate }}</mat-label>
                <input matInput [matDatepicker]="picker_from_dgfe" formControlName="from_date">
                <mat-datepicker-toggle matIconSuffix [for]="picker_from_dgfe"></mat-datepicker-toggle>
                <mat-datepicker #picker_from_dgfe></mat-datepicker>
            </mat-form-field>

            <mat-form-field class="tw-col-span-12 md:tw-col-span-6">
                <mat-label>{{ "PRINTERS.DETAIL.TO" | translate }}</mat-label>
                <input matInput [matDatepicker]="picker_to_dgfe" 
                    [min]="dgfeForm.get('from_date')?.value"
                    formControlName="to_date">
                <mat-datepicker-toggle matIconSuffix [for]="picker_to_dgfe"></mat-datepicker-toggle>
                <mat-datepicker #picker_to_dgfe></mat-datepicker>
            </mat-form-field>

            <div class="tw-col-span-12 md:tw-col-span-6">
                <app-action-btn variant="stroked" [fullWidth]="true"
                    class="tw-w-full"
                    [disabled]="dgfeForm.invalid || !dgfeForm.controls.from_date.value || 
                        !dgfeForm.controls.to_date.value" 
                    (click)="readDgfeBetween()">
                    {{'PRINTERS.DETAIL.READ_DGFE_SELECTION' | translate}}
                </app-action-btn>
            </div>

            <div class="tw-col-span-12 md:tw-col-span-6">
                <app-action-btn variant="stroked" [fullWidth]="true"
                    class="tw-w-full"
                    (click)="readDgfe()">
                    {{'PRINTERS.DETAIL.READ_DGFE_ALL' | translate}}
                </app-action-btn>
            </div>

            <div class="tw-col-span-12 md:tw-col-span-6">
                <app-action-btn variant="stroked" [fullWidth]="true"
                    class="tw-w-full"
                    [disabled]="dgfeForm.invalid || !dgfeForm.controls.from_date.value || 
                        !dgfeForm.controls.to_date.value" 
                    (click)="printDgfeBetween()">
                    {{'PRINTERS.DETAIL.PRINT_DGFE_SELECTION' | translate}}
                </app-action-btn>
            </div>

            <div class="tw-col-span-12 md:tw-col-span-6">
                <app-action-btn variant="stroked" [fullWidth]="true"
                    class="tw-w-full"
                    (click)="printDgfe()">
                    {{'PRINTERS.DETAIL.PRINT_DGFE_ALL' | translate}}
                </app-action-btn>
            </div>

            <div class="tw-col-span-12 md:tw-col-span-6">
                <app-action-btn variant="stroked" [fullWidth]="true"
                    class="tw-w-full"
                    [disabled]="dgfeForm.invalid || !dgfeForm.controls.from_date.value || 
                        !dgfeForm.controls.to_date.value" 
                    (click)="saveDgfeBetween()">
                    {{'PRINTERS.DETAIL.SAVE_DGFE_SELECTION' | translate}}
                </app-action-btn>
            </div>

            <div class="tw-col-span-12 md:tw-col-span-6">
                <app-action-btn variant="stroked" [fullWidth]="true"
                    class="tw-w-full"
                    (click)="saveDgfe()">
                    {{'PRINTERS.DETAIL.SAVE_DGFE_ALL' | translate}}
                </app-action-btn>
            </div>
            
            @if (downloadSelectionLink) {
                <div class="tw-col-span-12 md:tw-col-span-6">
                    <app-action-btn variant="raised" [fullWidth]="true"
                        class="tw-w-full"
                        (click)="downloadFile(downloadSelectionLink, 
                            getDownloadSelectionLinkFilename(dgfeForm.controls.from_date.value || '',dgfeForm.controls.to_date.value || '' ))">
                        {{'PRINTERS.DETAIL.DOWNLOAD_DGFE_SELECTION' | translate}}
                    </app-action-btn>
                </div>
            }

            @if (downloadAllLink) {
                <div class="tw-col-span-12 md:tw-col-span-6">
                    <app-action-btn variant="raised"  [fullWidth]="true"
                        class="tw-w-full"
                        (click)="downloadFile(downloadAllLink, 'dgfe_read.txt')">
                        {{'PRINTERS.DETAIL.DOWNLOAD_DGFE_ALL' | translate}}
                    </app-action-btn>
                </div>
            }
        </section>
    </app-card>
</div>